<div class="container-room-amenities" [ngClass]="{'desktop': !isMobile}">
  <div class="box-left">
    <span class="title-amenities" *ngIf="showTitle">
      <app-ds-typography
        [size]="fontSize.XXS"
        [color]="fontColor.Primary"
        [text]="'HOTELS_MODULE.DETAIL_DESCRIPTION.AMENITIES'| transloco">
      </app-ds-typography>
    </span>
    <div class="amenities" *ngIf="hasAmenityIcons">
      <ng-container *ngFor="let amenity of roomAmenitiesWithIcon">
        <div *ngIf="amenity.Icon" class="amenities-item" >
          <img loading="lazy" [src]="amenity.Icon | baseImage : AMENITIES_BASE_PATH">
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="showSeeMore" class="box-right" [ngClass]="{'desktop': !isMobile}">
    <div class="box-right__see-more">
      <app-ds-button-link
        [label]="'SEE_MORE' | transloco"
        [fontSize]="fontSize.XXS"
        [iconSize]="14"
        [type]="buttonLinkType.Secondary"
        [icon]="chevronRight"
        [iconPosition]="buttonLinkIconPosition.Right"
        (clickEvent)="toggleShowAmenitiesModal()">
      </app-ds-button-link>
    </div>
  </div>

  <app-swipe-up
    [showSwipeUp]="showAmenitiesModal"
    [showHeader]="true"
    [title]="'HOTELS_MODULE.DETAIL_DESCRIPTION.AMENITIES' | transloco"
    (toggleShowSwipeUp)="toggleShowAmenitiesModal()">
    <ng-container content>
      <app-amenities-detail
        [amenities]="amenities | amenitiesRoomVm: amenities.length : true">
      </app-amenities-detail>
    </ng-container>
  </app-swipe-up>

  <ng-container *ngIf="showAmenitiesModalDesktop">
    <app-modal
      [width]="476"
      [classType]="'white'"
      [showHeader]="true"
      [title]="'HOTELS_MODULE.DETAIL_DESCRIPTION.AMENITIES' | transloco"
      (toggleModal)="toggleShowAmenitiesModal()">
      <ng-container content>
        <app-amenities-detail
          [amenities]="amenities | amenitiesRoomVm: amenities.length : true">
        </app-amenities-detail>
      </ng-container>
    </app-modal>
  </ng-container>
</div>
